import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { reportCategories } from '../utils/reportConfig';

const ReportNav = ({ activeTab, onTabChange, collapsed, onToggleCollapse }) => {
  const [expandedCategories, setExpandedCategories] = useState({
    revenue: true,
    risk: true,
    operations: true
  });

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  return (
    <nav 
      className={`${collapsed ? 'w-14' : 'w-48'} min-h-full flex-shrink-0 border-r border-white/10 bg-black/30 transition-all duration-200 overflow-y-auto`} 
      data-testid="report-nav"
    >
      <div className="p-2">
        {/* Collapse Toggle */}
        <button 
          onClick={onToggleCollapse}
          className="w-full flex items-center justify-center p-1.5 mb-2 rounded hover:bg-white/10 transition-colors"
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          <ChevronDown className={`w-4 h-4 transition-transform ${collapsed ? '-rotate-90' : 'rotate-90'}`} />
        </button>
        
        {reportCategories.map((category) => (
          <div key={category.id} className="mb-1">
            {/* Category Header */}
            {!collapsed && (
              <button
                onClick={() => toggleCategory(category.id)}
                className="w-full flex items-center justify-between px-2 py-1 text-[9px] uppercase tracking-wider text-muted-foreground hover:text-white transition-colors"
                data-testid={`category-${category.id}`}
              >
                <span className="font-semibold truncate">{category.label}</span>
                <ChevronDown className={`w-3 h-3 transition-transform ${expandedCategories[category.id] ? '' : '-rotate-90'}`} />
              </button>
            )}
            
            {/* Report Items */}
            {(collapsed || expandedCategories[category.id]) && (
              <div className="space-y-0.5">
                {category.reports.map((report) => {
                  const Icon = report.icon;
                  const isActive = activeTab === report.id;
                  
                  return (
                    <button
                      key={report.id}
                      onClick={() => onTabChange(report.id)}
                      className={`w-full flex items-center gap-2 px-2 py-1.5 rounded text-xs transition-all duration-150 ${
                        isActive
                          ? 'bg-cyan-500/20 text-cyan-400 border-l-2 border-cyan-400'
                          : 'text-muted-foreground hover:text-white hover:bg-white/5'
                      }`}
                      data-testid={`nav-${report.id}`}
                      title={report.label}
                    >
                      <Icon className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-cyan-400' : ''}`} />
                      {!collapsed && <span className="truncate">{report.label}</span>}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default ReportNav;
